import type { CSSObject } from '@emotion/react';

import type {
  ThemeType,
} from '@n3/css-base';

export const createValueContainerStyle = (
  isSmall: boolean,
  {
    colors,
    fonts,
    select,
  }: ThemeType,
) => (baseCSS: CSSObject, {
  selectProps: {
    isDisabled,
  },
}: {
  selectProps: {
    small?: boolean;
    isDisabled?: boolean;
  };
}): CSSObject => ({
  ...(isSmall ? fonts.INPUT_SMALL : fonts.INPUT),
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexWrap: 'wrap',
  WebkitOverflowScrolling: 'touch',
  position: 'relative',
  overflow: 'hidden',
  padding: '0px 6px',
  color: isDisabled
    ? colors[select.SINGLE_VALUE_TEXT_COLOR_DISABLED]
    : colors[select.SINGLE_VALUE_TEXT_COLOR],
});
